import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="advanced-fiscal-years"
export default class extends Controller {
  private formTarget!: HTMLFormElement
  private saveButtonTarget!: HTMLButtonElement
  private warningTarget!: HTMLElement

  static targets = ['form', 'saveButton', 'warning']

  private digest!: Record<string, unknown>

  connect(): void {
    this.digest = this.formDigest()
  }

  formTargetConnected(element: HTMLFormElement): void {
    element.addEventListener('change', this.handleFormChange.bind(this))
  }

  formTargetDisconnected(element: HTMLFormElement): void {
    element.removeEventListener('change', this.handleFormChange.bind(this))
  }

  handleFormChange(_event: Event): void {
    const changed = this.digestHasChanged()
    this.saveButtonTarget.disabled = !changed
    this.saveButtonTarget.classList.toggle('sf-button--primary', changed)
    this.saveButtonTarget.classList.toggle('sf-button--secondary', !changed)

    if (this.ledgersPerYearHasChanged()) {
      this.warningTarget.classList.remove('sf-hidden')
    } else {
      this.warningTarget.classList.add('sf-hidden')
    }
  }

  ledgersPerYearHasChanged(): boolean {
    return (
      this.digest['company[ledgers_per_year]'] !==
      this.formDigest()['company[ledgers_per_year]']
    )
  }

  formDigest(): Record<string, unknown> {
    const formData = new FormData(this.formTarget)
    formData.delete('authenticity_token')

    return Object.fromEntries(formData.entries())
  }

  digestHasChanged(): boolean {
    return JSON.stringify(this.digest) !== JSON.stringify(this.formDigest())
  }
}
